<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/27QWzb/tc-custom/9781429961011.jpg?1737763724380" alt="This image is the cover for the book The Talented Miss Highsmith"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Talented Miss Highsmith
      </h1>
      <p class="bookDescription body article font2">
        <b>A biography of the novelist who created Tom Ripley that is “both dazzling and definitive . . . as original as its contemptible, miserable, irresistible subject” (<i>Los Angeles Times</i>).</b><br/><br/><b>A New York Times Notable Book * A Lambda Literary Award Winner * An Edgar Award Nominee * An Agatha Award Nominee * A Publishers Weekly Pick of the Week</b><br/><br/>Patricia Highsmith, one of the great writers of twentieth-century American fiction, had a life as darkly compelling as that of her famed “hero-criminal,” the talented Tom Ripley. Joan Schenkar maps out this richly bizarre life from her birth in Texas to Hitchcock’s filming of her first novel, <i>Strangers on a Train</i>, to her long, strange self-exile in Europe. We see her as a secret writer for the comics, a brilliant creator of disturbing fictions, and an erotic predator with dozens of women (and a few good men) on her love list. <i>The Talented Miss Highsmith</i> is the first literary biography with access to Highsmith’s whole story: her closest friends, her oeuvre, her archives. It’s a compulsive page-turner unlike any other, a book worthy of Highsmith herself.<br/><br/>“Schenkar’s writing is witty, sharp and light-handed, a considerable achievement given the immense detail.” —Jeanette Winterson, <i>The New York Times Book Review</i><br/><br/>“This is no ordinary biography . . . <i>The Talented Miss Highsmith</i> breaks much ground in connecting Highsmith’s diabolical tales with the real women who prompted her strongest passions.” —Janet Maslin, <i>The New York Times</i><br/><br/>“Captures the writer in all her sullen, sinister, ambivalent glory.” —Tina Jordan, <i>Entertainment Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joan Schenkar
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Macmillan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?349f18d9